const ROUTE_QUIZ = process.env.ROUTE_QUIZ

export function getquiz (options) {
  return options.$http.get(ROUTE_QUIZ + '/' + options.slug + '.json', options.options).then((response) => {
    response.success = (Boolean)(response && response.ok && response.data)
    return response
  }, (response) => {
    response.success = false
    return response
  })
}

export function setresults (options) {
  return options.$http.post(ROUTE_QUIZ + '.json', options.post, options.options).then((response) => {
    response.success = (Boolean)(response && response.ok && response.data)
    return response
  }, (response) => {
    response.success = false
    return response
  })
}



// WEBPACK FOOTER //
// ./src/api/quizApi.js